/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getHotelVoucherDetailsApi } from '../../../api/hotelApi';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import {
  formatCurrency,
  formatDate,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import { DATE_MONTH_YEAR_VIEW_FORMAT } from '../../../shared/constants/Constants';
import './BookingDetails.scss';
import './Voucher.scss';
import StarRating from '../search-results/StarRating';

function VoucherPage() {
  const [searchParams] = useSearchParams();
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({});
  const [hasTicket, setHasTicket] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const passengerRef = useRef([]);

  const getHotelVoucherDetails = async () => {
    setLoading(true);
    const response = await getHotelVoucherDetailsApi(transactionId);
    if (response?.HotelInvoice) {
      const data = response.HotelInvoice || {};
      let paxList = data.hotelpax;
      paxList = Array.isArray(paxList) ? paxList : [paxList];
      passengerRef.current = paxList;
      setBookingDetails(data);
      setHasTicket(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Voucher Details',
        description:
          response?.Root?.Message ||
          'Error while fetching hotel voucher details',
      });
      setHasTicket(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    getHotelVoucherDetails();
  }, []);

  const onPrint = () => {
    window.print();
  };

  const getLeadPaxName = () => {
    let name = '';
    if (bookingDetails.leadpassenger_firstname)
      name += ` ${bookingDetails.leadpassenger_firstname}`;
    if (bookingDetails.leadpassenger_lastname)
      name += ` ${bookingDetails.leadpassenger_lastname}`;
    return name;
  };
  return (
    <section className="hotel-voucher">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {hasTicket !== undefined && hasTicket && (
        <section className="hotel-voucher_section">
          <div className="hotel-voucher_container">
            <section className="hotel-voucher_heading d-flex justify-content-between align-items-center mb-3">
              <h3>Booking Voucher</h3>
              <div>
                Voucher Date :{' '}
                {formatDate(
                  getNewDate(bookingDetails.tx_date.split(' ')[0]),
                  DATE_MONTH_YEAR_VIEW_FORMAT,
                )}
              </div>
            </section>
            <section className="hotel-details mb-3">
              <div className="booking-info">
                <table className="w-100">
                  <tbody>
                    <tr>
                      <td>File No.</td>
                      <td>{bookingDetails.confirmationno}</td>
                    </tr>
                    <tr>
                      <td>Booking Id</td>
                      <td>{bookingDetails.txid}</td>
                    </tr>
                    <tr>
                      <td>Supplier Reference</td>
                      <td>{bookingDetails.supplier_reference}</td>
                    </tr>
                    <tr>
                      <td>Voucher Info</td>
                      <td>{bookingDetails.voucherinfo}</td>
                    </tr>
                    <tr>
                      <td>Booking Status</td>
                      <td>{bookingDetails.booking_status}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="hotel-info ">
                <table>
                  <tbody>
                    <tr>
                      <td>Hotel Name</td>
                      <td>
                        {bookingDetails.hotel_name}
                        <StarRating rating={bookingDetails.hotel_rating} />
                      </td>
                    </tr>
                    <tr>
                      <td>Room Type</td>
                      <td>{bookingDetails.room_type}</td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td>
                        {bookingDetails.hotel_address},
                        {bookingDetails.hotel_cityreference}
                      </td>
                    </tr>
                    <tr>
                      <td>check in </td>
                      <td>
                        {bookingDetails.checkin_time !== ''
                          ? formatDate(
                              getNewDate(
                                bookingDetails.checkin_time.split(' ')[0],
                              ),
                              DATE_MONTH_YEAR_VIEW_FORMAT,
                            )
                          : ''}
                      </td>
                    </tr>
                    <tr>
                      <td>Check Out</td>
                      <td>
                        {bookingDetails.checkout_time !== ''
                          ? formatDate(
                              getNewDate(
                                bookingDetails.checkout_time.split(' ')[0],
                              ),
                              DATE_MONTH_YEAR_VIEW_FORMAT,
                            )
                          : ''}
                      </td>
                    </tr>
                    <tr>
                      <td>Hotel Contact</td>
                      <td>{bookingDetails.hotel_contact}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <section className="passenger-details mb-2">
              <table
                width="100%"
                style={{
                  border: '1px solid #e2e2e2',
                  borderSpacing: '0',
                }}
              >
                <tbody>
                  <tr>
                    <td
                      colSpan={3}
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        padding: '6px ',
                        borderBottom: '1px solid #e2e2e2',
                      }}
                    >
                      Guest Details
                    </td>
                  </tr>
                  {passengerRef.current.length > 0 &&
                    passengerRef.current.map((pax, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            padding: '6px ',
                          }}
                          colSpan={index === 0 ? 1 : 3}
                        >
                          <div
                            style={{
                              fontSize: '12px',
                              fontWeight: '300',
                            }}
                          >
                            Name
                          </div>
                          <div
                            style={{ fontWeight: '500' }}
                          >{`${pax.salutation} ${pax.firstname} ${pax.lastname}`}</div>
                        </td>
                        {index === 0 && (
                          <td
                            style={{
                              padding: '6px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '300',
                              }}
                            >
                              Email
                            </div>
                            <div style={{ fontWeight: '500' }}>{pax.email}</div>
                          </td>
                        )}
                        {index === 0 && (
                          <td
                            style={{
                              padding: '6px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '300',
                              }}
                            >
                              Phone
                            </div>
                            <div style={{ fontWeight: '500' }}>
                              {pax.phoneno}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </section>
            <section className="remarks">
              <table>
                <thead>
                  <tr>
                    <th>Terms & Conditions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <ul style={{ paddingLeft: '12px' }}>
                        <li className="my-2">
                          <strong>Naming List:</strong> Please note that while
                          your booking has been confirmed and is guaranteed, the
                          rooming list with your name may not be adjusted in the
                          hotel reservation system until closer to arrival.
                        </li>
                        <li className="my-2">
                          <strong>Late Arrival:</strong> For delayed arrival,
                          please notify your booking office so that we can
                          advise the property accordingly. If you do not arrive
                          on the first night when your accommodation is booked,
                          the property has full right to release your room and
                          charge in full. Therefore, kindly inform in advance to
                          avoid inconvenience in your trip.
                        </li>
                        <li className="my-2">
                          Please note that every attempt is made to adher to
                          special requests, but they cannot be guaranteed.
                        </li>
                        <li className="my-2">
                          Credit Card Guarantee: Please note hotels may ask for
                          a credit card imprint or cash depositat the time of
                          check in to cover incidentals. This amount may vary
                          from hotel to hotel.
                        </li>
                        <li className="my-2">
                          If you have a problem with the hotelier or service
                          suppliers regarding the reservations or vouchers,
                          please contact the emergency contact number:
                        </li>
                        <li className="my-2">
                          We hope that you have a wonderful stay and a hassle
                          free trip. In case of any problem during your stay,
                          please feel free to contact us and we would be happy
                          to help you.
                        </li>
                        <li className="my-2">
                          Before travelling, please ensure that this reservation
                          has been reconfirmed by your agent. The supplier will
                          not be responsible for an unconfirmed booking
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
        </section>
      )}
    </section>
  );
}

export default VoucherPage;
